import { AxiosError } from 'axios'
import { useFormErrorStore } from '@/stores/formError'
import { storeToRefs } from 'pinia'
import { captureException } from '@sentry/vue'
import { useI18n } from 'vue-i18n'

export const useErrorModal = () => {
  const { t } = useI18n()

  const showErrorModal = (message: string, status?: string) => {
    const formErrorStore = useFormErrorStore()
    const { formErrorModal, formError, formErrorStatus } = storeToRefs(formErrorStore)

    formErrorModal.value = true
    formError.value = message
    if (status) formErrorStatus.value = status
  }

  const setErrorModalOnError = (err: unknown) => {
    captureException(err)
    const isAxiosError = err instanceof AxiosError

    if (!isAxiosError) {
      showErrorModal(t('home.toastError'))
      throw err
    }

    const errorMessage = err.response?.data?.data?.error_message ?? t('home.toastError')
    const errorStatus = err.response?.status

    showErrorModal(errorMessage, errorStatus?.toString())
    throw err
  }

  return {
    showErrorModal,
    setErrorModalOnError
  }
}
